import React from "react"
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa"
export default [
  {
    icon: <FaFacebookF />,
    url: "https://www.facebook.com/ChedraTaxITP/",
  },
  {
    icon: <FaLinkedinIn />,
    url: "https://linkedin.com/?lang=en",
  },
  {
    icon: <FaInstagram />,
    url: "https://instgram.com/?lang=en",
  },
]
